export default __webpack_public_path__ + "static/media/Sia.83958f16.png";